import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Inbox, FolderKanban, Wrench, Users, MapPin, MailWarning, ArrowUpRight } from 'lucide-react';
import { adminStatus } from '@/lib/api';
import { useSite } from '@/context/SiteContext';

const CARD = [
  { key: 'projects', label: 'Projects', to: '/admin/content/projects', icon: FolderKanban },
  { key: 'services', label: 'Services', to: '/admin/content/services', icon: Wrench },
  { key: 'equipment', label: 'Equipment', to: '/admin/content/equipment', icon: Wrench },
  { key: 'clients', label: 'Clients', to: '/admin/content/clients', icon: Users },
  { key: 'locations', label: 'Locations', to: '/admin/content/locations', icon: MapPin },
  { key: 'enquiries', label: 'Enquiries', to: '/admin/enquiries', icon: Inbox },
];

export default function AdminDashboard() {
  const [status, setStatus] = useState(null);
  const { site } = useSite();

  useEffect(() => { adminStatus().then(setStatus).catch(() => {}); }, []);
  const counts = status?.counts || {};

  return (
    <div>
      <h1 className='font-head text-2xl font-semibold text-[#20272A]'>Dashboard</h1>
      <p className='text-sm text-[#20272A]/50'>Manage all website content from one place.</p>

      {status && !status.emailEnabled && (
        <div className='mt-6 flex items-start gap-3 rounded-xl border border-[#B88A3B]/30 bg-[#B88A3B]/8 p-4' data-testid='email-disabled-note'>
          <MailWarning size={18} className='mt-0.5 shrink-0 text-[#B88A3B]' />
          <p className='text-sm text-[#20272A]/75'>
            <span className='font-medium'>Email notifications are currently disabled.</span> Enquiries are saved here in the inbox. To also receive emails at
            {' '}<span className='font-medium'>slecoimbatore@gmail.com</span>, add <code className='rounded bg-white px-1'>SENDGRID_API_KEY</code> and <code className='rounded bg-white px-1'>SENDER_EMAIL</code> on the server.
          </p>
        </div>
      )}

      <div className='mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3'>
        {CARD.map((c) => (
          <Link key={c.key} to={c.to} className='group rounded-2xl border border-[#20272A]/10 bg-white p-6 transition-shadow hover:shadow-[0_14px_40px_rgba(32,39,42,0.08)]'>
            <div className='flex items-center justify-between'>
              <span className='flex h-11 w-11 items-center justify-center rounded-xl bg-[#075B61]/8 text-[#075B61]'><c.icon size={20} /></span>
              <ArrowUpRight size={18} className='text-[#20272A]/30 transition-colors group-hover:text-[#B88A3B]' />
            </div>
            <div className='mt-4 font-mono-num text-3xl font-medium text-[#20272A]'>{counts[c.key] ?? '—'}</div>
            <div className='mt-1 text-sm text-[#20272A]/55'>{c.label}</div>
          </Link>
        ))}
      </div>

      <div className='mt-8 rounded-2xl border border-[#20272A]/10 bg-white p-6'>
        <h2 className='font-head text-lg font-semibold text-[#20272A]'>Quick edit</h2>
        <div className='mt-4 flex flex-wrap gap-3'>
          <Link to='/admin/singleton/hero' className='rounded-lg border border-[#20272A]/12 px-4 py-2 text-sm text-[#20272A]/75 hover:border-[#075B61]/40 hover:text-[#075B61]'>Homepage Hero</Link>
          <Link to='/admin/singleton/about' className='rounded-lg border border-[#20272A]/12 px-4 py-2 text-sm text-[#20272A]/75 hover:border-[#075B61]/40 hover:text-[#075B61]'>About / Vision</Link>
          <Link to='/admin/singleton/site' className='rounded-lg border border-[#20272A]/12 px-4 py-2 text-sm text-[#20272A]/75 hover:border-[#075B61]/40 hover:text-[#075B61]'>Site & Contact</Link>
        </div>
      </div>
    </div>
  );
}
